import { Helmet } from "react-helmet-async";
import * as React from "react";
import { ContactPageContainer, Container, Title } from "../ContactPage/ContactPage.styled";
import { Content } from "./UserAgreementPage.styled";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { HEADER_TYPE } from "../../constants";
import { useStores } from "../../stores";

interface UserAgreementPageProps {}

export const UserAgreementPage = observer(({}: UserAgreementPageProps) => {
	const { settingsStore } = useStores();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
		settingsStore.showFooter();
	}, []);

	return (
		<>
			<Helmet>
				<title>User Agreement | MUSICABINET</title>
				<meta name="description" content="" />
			</Helmet>

			<ContactPageContainer>
				{settingsStore.lang === "ru" && (
					<Container>
						<Title>Пользовательское соглашение</Title>

						<Content>
							<div>
								<ol>
									<li>
										<div>Общие положения</div>

										<ol>
											<li>
												В настоящем Пользовательском соглашении (далее - Соглашение) применяются следующие понятия и
												определения:
												<ol>
													<li>
														<b>Пользователь</b> - физическое лицо, зарегистрировавшее профиль пользователя в Приложении
														в установленном на Веб-сайте порядке
													</li>

													<li>
														<b>Веб-сайт</b> - это набор интегрированного аппаратного и программного обеспечения,
														доступный в сети Интернет и расположенный в домене musicabinet.ru и всех зонах поддоменов
														и/или приложении для Android или iOS (Google Play и AppStore соответственно), содержимое
														которого составляют результаты интеллектуальной деятельности, включая тексты, музыкальные,
														графические, текстовые, фотографические и иные произведения, пользовательский и визуальный
														интерфейс, товарные знаки, логотипы, программы для ЭВМ, базы данных, дизайн, структура,
														выбор, координация, внешний вид и общий стиль, входящего в состав технических инструментов
														Веб-сайта и иные объекты интеллектуальной собственности вмести или по отдельности,
														содержащиеся на указанном сайте
													</li>

													<li>
														<b>Учетная запись пользователя</b> - это Средство аутентификации и Личная информация
														Пользователя, хранящиеся на серверах Веб-сайта.
													</li>

													<li>
														<b>Приложение</b> - это программа и/или база данных, включая Веб-сайт и мобильные
														приложения, предназначенные для предоставления доступа Пользователя к Сервису с
														использованием Устройства Пользователя.
													</li>

													<li>
														<b>Musicabinet</b> – используемое в тексте Соглашения наименование Общества с ограниченной
														ответственностью «Мьюзикабинет» (ИНН 1660299477, сокращенное наименование ООО
														«Мьюзикабинет», наименование на английском языке – «Musicabinet» Limited Liability Company,
														«Musicabinet» LLC) и предоставляющая услуги дистанционного обучения игре на различных
														музыкальных инструментах с помощью Приложения.
													</li>

													<li>
														<b>Устройство</b> – персональный компьютер, планшет, мобильный телефон, коммуникатор,
														смартфон или другое устройство, позволяющее использовать Приложение в зависимости от его
														функционального назначения.
													</li>

													<li>
														<b>Сервис</b> - это набор услуг по дистанционному обучению игре на различных музыкальных
														инструментах, которые Musicabinet предоставляет Пользователю..
													</li>

													<li>
														<b>Контент</b> - это изображения, текстовые, аудио- и видеоматериалы, а также другие объекты
														авторского права и / или смежных прав, а также информация и коммуникации любого характера,
														кроме указанных выше в Приложении.
													</li>

													<li>
														<b>Профиль</b> - это личный раздел Веб-сайта, к которому Пользователь имеет доступ после
														регистрации и авторизации на Веб-сайте.
													</li>

													<li>
														<b>Личный кабинет</b> - специализированный защищенный информационный раздел, доступ к
														которому предоставляется Пользователю в целях использования и хранения персональной
														информации Пользователя, просмотра доступного функционала Сервиса и управления им в
														соответствии с условиями использования Сервиса.
													</li>

													<li>
														<b>Дополнительные функциональные возможности Веб-сайта</b> - это функциональные возможности
														приложения, предоставляемые на Веб-сайте.
													</li>

													<li>
														<b>Техническая поддержка</b> – сервис Веб-сайта, который обеспечивает оказание помощи
														Пользователям при использовании Приложения.
													</li>

													<li>
														<b>Политика конфиденциальности</b> – документ, находящийся по адресу: ______ и раскрывающий
														цели, способы, с помощью которых Сайт собирает, использует и раскрывает персональные данные
														(личную информацию) посетителей сайта, а также управляет ими.
														<ol>
															<li>
																Соглашение является публичной офертой, определяющей условия предоставления
																неисключительного права на использование Приложения в соответствии с его условиями, а
																также в соответствии с требованиями действующего законодательства Российской Федерации.
																Использование Приложения возможно не иначе как путем присоединения Пользователя к
																условиям Соглашения посредством выражения согласия.
															</li>

															<li>
																В Соглашении могут использоваться другие термины и определения, не указанные в разделе
																1. В этом случае толкование понятия должно соответствовать тексту Соглашения.
															</li>

															<li>
																Пользователь может использовать Приложение в пределах заявленной им функциональности и
																назначения, в том числе: регистрация и/или авторизация на Веб-сайте.
																<br />
																подбор и оплата учебных программ и курсов.
																<br />
																просмотр Материалов, размещенных на Веб-сайте, в том числе в учебных целях.
																<br />
																просмотр статистики тренировок для самоконтроля.
																<br />
																отправка текстовых сообщений с элементами мультимедиа другим пользователям Приложения.
																<br />
																размещение или отображение любого Пользовательского контента (включая его/ее
																собственный) на Веб-сайте с учетом ограничений, указанных в разделе 2. выбор и оплата
																товаров в интернет-магазине.
															</li>

															<li>
																Полное и безусловное принятие Пользователем условий следующих документов (далее -
																"обязательные к исполнению документы") является предварительным условием для
																использования Приложения и предоставления Сервиса: Соглашение, регулирующее порядок
																использования функционала Приложения. Политика конфиденциальности, определяющая порядок
																сбора, обработки и хранения персональной информации пользователей. Согласие на обработку
																персональных данных, выражающее согласие Пользователя на предоставление, обработку,
																хранение и распространение пользователем своих персональных данных Пользователь
																подтверждает, что: полностью ознакомлен с условиями Соглашения, прежде чем использовать
																Приложение и / или Сервис, предоставляемый на его основе; принимает и соглашается со
																всеми условия Соглашения в полном объеме, без каких-либо исключений или ограничений со
																своей стороны, и соглашается соблюдать их или прекратить использование Приложения. Если
																Пользователь не согласен с условиями Соглашения, он обязуется немедленно прекратить
																любое использование Приложения и предоставляемых на его основе Услуг.
															</li>
														</ol>
													</li>
												</ol>
											</li>
										</ol>
									</li>

									<li>
										<div>Общие условия использования Сервиса</div>
										<ol>
											<li>
												Просмотр Контента, размещенного в Приложении в открытом доступе, не требует регистрации и/или
												авторизации Пользователя.
											</li>
											<li>
												2.2. Любое другое использование Приложения разрешено только после завершения Пользователем
												регистрации и авторизации в Приложении в соответствии с условиями Соглашения.
											</li>
											<li>
												2.3. Перечень функциональных возможностей Приложения, требующих от Пользователя предварительной
												регистрации и авторизации, а также принятия дополнительных документов для использования
												Сервисов, при необходимости, определяется Musicabinet по собственному усмотрению и может быть
												изменен без согласия Пользователя в любой момент и без предварительного уведомления.
											</li>
											<li>
												2.4. Информация о Пользователе в Учетной записи и Профиле хранится и обрабатывается Musicabinet
												в соответствии с Политикой конфиденциальности.
											</li>
											<li>
												2.5. Зарегистрированный Пользователь самостоятельно определяет способы использования Профиля и
												другого функционала Приложения, что, ни при каких обстоятельствах не может противоречить
												Соглашению и требованиям действующего законодательства Российской Федерации.
											</li>
											<li>
												2.6. Пользователь принимает предоставленное право на использование Приложения на указанных
												условиях, а также право использовать Дополнительные функциональные возможности Веб-сайта в
												соответствии с выбранным Пользователем тарифом, и оплатить комиссию, если это предусмотрено
												условиями тарифа.
											</li>
											<li>
												2.7. При использовании Приложения Пользователю запрещается: - в любом виде копировать полностью
												или в любой части содержимое Приложения, Веб-сайта, в том числе, но не ограничиваясь - исходного
												кода, программного кода, а также дизайна, создания и/или использования программ и баз данных,
												являющихся частью Приложения, осуществлять их декомпиляции и модификации.
												<br />
												- размещать и/или распространять контент, на который Пользователь не получил обязательного
												согласия на его использование для неограниченного круга лиц.
												<br />
												- размещать и/или распространять Контент порнографического характера, а также пропагандировать
												порнографию и детскую эротику, а также рекламу интимных услуг.
												<br />
												- размещать и/или распространять любую иную запрещенную информацию, в том числе материалы
												экстремистского характера, направленные на ущемление прав и свобод человека по признаку расы,
												национальности, религии, языка и пола, подстрекающие к совершению насильственных действий в
												отношении человека или к бесчеловечному обращению с животными, призывающие к совершению иных
												противоправных действий, в том числе разъясняющие производство и применение оружия,
												наркотических средств и их прекурсоров и т.д.
												<br />
												- размещать и / или распространять информацию, унижающую честь и достоинство человека, а также
												причиняющую ущерб деловой репутации юридических лиц.
												<br />
												- размещать и / или распространять информацию из документов, удостоверяющих личность, или личную
												финансовую информацию.
												<br />
												- распространять рекламу в личных сообщениях Пользователям без их предварительного согласия и
												без согласия Musicabinet (нежелательная реклама).
												<br />
												- распространять информацию, побуждающую детей к совершению действий, угрожающих их жизни и/или
												здоровью, в том числе к причинению вреда их здоровью, самоубийству.
												<br />
												- распространять информацию, которая может призывать детей к употреблению наркотических средств,
												психотропных и/или одурманивающих веществ, табака, алкоголя и спиртосодержащих изделий, пива и
												напитков, полученных из него, к участию в азартных играх, занятию проституцией, бродяжничеством
												или попрошайничеством.
												<br />
												- распространять информацию, оправдывающую допустимость насилия и/или жестокости или побуждающую
												к совершению насильственных действий в отношении людей или животных.
												<br />
												- распространять информацию, отрицающую семейные ценности и вызывающую неуважение к родителям
												и/или другим членам семьи.
												<br />
												- распространять информацию, оправдывающую незаконное поведение.
												<br />
												- распространять информацию, содержащую нецензурные, оскорбительные выражения, клевету и иную
												несоответствующую действительности информацию.
												<br />
												- совершать иные действия, нарушающие требования действующего законодательства Российской
												Федерации.
												<br />
												Нарушение условий, указанных в разделе 2.7 Соглашения, является основанием для блокировки
												доступа Пользователя к использованию Приложения.
												<br />
											</li>
											<li>
												2.8. Если несмотря на запрет при использовании Приложения, Пользователь обнаружит Контент,
												который может быть определен как содержащий оскорбительную или неприличную информацию и/или иным
												образом нарушающим законодательство Российской Федерации и права третьих лиц, Пользователь
												обязан обратиться в службу технической поддержки. Такой запрос будет немедленно рассмотрен, а
												соответствующий Контент - удален в случае установления нарушений условий Соглашения и/или
												требований действующего законодательства Российской Федерации
											</li>
										</ol>
									</li>

									<li>
										<div>Права и обязанности Сторон</div>

										<ol>
											<li>Musicabinet обязан:</li>
											<li>
												3.1.1. Уведомлять Пользователя об изменении тарифов для оплаты предоставленного права
												использования Дополнительных функциональных возможностей Веб-сайта не менее чем за 10 рабочих
												дней до введения новых тарифов по электронной почте, указанной Пользователем при регистрации на
												Сайте.
											</li>
											<li>
												3.1.2. Выполнять иные обязанности в соответствии с действующим законодательством и Соглашением.
											</li>
											<li>
												3.1.3. Предоставлять Пользователю право на использование Приложения в рамках функционала
												Сервиса, а также право на использование Дополнительного Функционала в соответствии с выбранным
												тарифом.
											</li>
											<li>3.1.4. Обеспечивать работоспособность Сервиса и техническую поддержку Пользователей.</li>
											<li>
												3.1.5. Рассмотреть претензии правообладателей о нарушении прав интеллектуальной собственности в
												связи с использованием Приложения. Musicabinet принимает все необходимые меры к недопущению
												нарушений прав интеллектуальной собственности на Веб-сайте, в Приложении, и в случае обнаружения
												такого нарушения немедленно принимает меры к блокировке доступа к Контенту, нарушающему права
												интеллектуальной собственности. Musicabinet имеет право:
											</li>
											<li>
												3.2.1. Расторгнуть Соглашение с Пользователем или приостановить его действие в отношении, если
												Пользователь нарушает условия Соглашения. путем блокировки или иного ограничения личного
												кабинета Пользователя.
											</li>
											<li>
												3.2.2. Отказать в праве на использование Дополнительных функциональных возможностей Веб-сайта до
												его оплаты.
											</li>
											<li>
												3.2.3. Приостанавливать доступ Пользователя к Дополнительному функционалу Сайта в случае
												истечения срока доступа, если такие ограничения предусмотрены используемым тарифом.
											</li>
											<li>
												3.2.4. Ограничивать действия отдельного Пользователя, если такие действия ставят под угрозу
												устойчивую работу Веб-сайта, Приложения и/или Сервисов;
											</li>
											<li>
												3.2.5. Проводить работы по плановому техническому и программному обслуживанию Веб-сайта,
												Приложения, Сервисов.
											</li>
											<li>3.2.6. Изменять в одностороннем порядке условия Соглашения.</li>
											<li>
												3.2.7. В случае неоднократного нарушения условий Соглашения и/или требований законодательства
												Российской Федерации, Musicabinet оставляет за собой право полностью заблокировать профиль
												Пользователя (учетную запись) или ограничить (прекратить) предоставление права пользования
												Услугами на определенный период.
											</li>
											<li>
												3.2.8. Musicabinet оставляет за собой право в одностороннем порядке удалить любой Контент из
												содержимого Веб-ссайта или временно ограничить к нему доступ.
											</li>
											<li>
												3.2.9. Если Musicabinet удалил Контент как нарушающий условия документов, указанных в пункте 1.5
												Соглашения, прав третьих лиц и/или законодательство Российской Федерации, и Пользователь
												считает, что Контент был удален необоснованно, Пользователь вправе оспорить такие действия,
												путем направления письма в службу технической поддержки. Пользователь обязан:
											</li>
											<li>
												3.3.1. Соблюдать условия использования Приложения, установленные документами, указанными в
												пункте 1.5 Соглашения.
											</li>
											<li>
												3.3.2. Выполнять иные обязанности в соответствии с действующим законодательством Российской
												Федерации и Соглашением.
											</li>
											<li>3.4. Пользователь имеет право:</li>
											<li>3.4.1.В одностороннем порядке отказаться от исполнения Соглашения.</li>
											<li>
												3.4.2. Осуществлять иные права в соответствии с действующим законодательством Российской
												Федерации и Соглашением.
											</li>
										</ol>
									</li>

									<li>
										<div>Предоставление Дополнительных функциональных возможностей Веб-сайта и порядок расчетов</div>

										<ol>
											<li>
												4.1. Право Пользователя на использование Дополнительных функциональных возможностей Веб-сайта
												регулируется условиями выбранного Пользователем тарифа в зависимости от наименования, состава и
												объема предоставляемых прав.
											</li>
											<li>
												4.2. Предварительная оплата предоставляемых прав на использование Дополнительных функциональных
												возможностей Веб-сайта производится Пользователем в зависимости от выбранного тарифа
												единоразовым платежом или путем внесения абонентской платы.
											</li>
											<li>
												4.3. Расчеты по Договору осуществляются безналичным способом посредством использования сервиса
												оплаты, размещенного на Веб-сайте и в Приложении.
											</li>
										</ol>
									</li>

									<li>
										<div>Гарантии и ответственность Musicabinet</div>

										<ol>
											<li>
												5.1. Musicabinet вправе изменять без предварительного уведомления Пользователя название и состав
												предоставляемых функций Приложения, поскольку Услуги и Дополнительные функциональные возможности
												Приложения находятся в процессе постоянного обновления и дополнения новыми функциональными
												возможностями и Контентом.
											</li>
											<li>
												5.2. Musicabinet не несет ответственности за перебои в предоставлении Услуг и Дополнительных
												функциональных возможностей Веб-сайта в случае сбоя программного обеспечения или оборудования
												сторонних производителей (интернет-провайдеров и других).
											</li>
											<li>
												5.3. Musicabinet не несет ответственности перед Пользователем за приостановку Предоставления
												Услуг и дополнительных функциональных возможностей Веб-сайта на основании требований
												государственных органов, суда, правоохранительных и надзорных органов.
											</li>
											<li>
												5.4. Musicabinet не несет ответственности за перебои в доступе и использовании Сервисов и
												дополнительных функциональных возможностей Веб-сайта, связанных с заменой оборудования,
												программного обеспечения или другими работами, вызванными обслуживанием и развитием аппаратного
												обеспечения Приложения, при условии уведомления Пользователя о перебоях в предоставлении Услуг и
												дополнительной функциональности Веб-сайта.
											</li>
											<li>
												5.5. Musicabinet не несет ответственности за функционирование и доступность отдельных сегментов
												коммуникационной сети Интернет. Musicabinet не гарантирует возможность обмена информацией с теми
												узлами или серверами, которые временно или постоянно недоступны через сеть связи.
											</li>
											<li>
												5.6. Musicabinet не несет ответственности за обеспечение безопасности аппаратного и программного
												обеспечения Пользователя, используемого для работы Сервисов и дополнительных функциональных
												возможностей Веб-сайта.
											</li>
											<li>
												5.7. Musicabinet не несет ответственности за действия Пользователя в связи с использованием
												Сервисов и дополнительных функциональных возможностей Веб-сайта.
											</li>
											<li>
												5.8. Размер ущерба, причиненного Пользователю виновными действиями или бездействиями Musicabinet
												в любом случае не может превышать стоимости предоставленных Пользователю прав использования
												функционала Приложения, оплаченных за один расчетный период, в котором возник такой ущерб.
											</li>
											<li>
												5.9. Musicabinet вправе отправлять Пользователю информационные сообщения в личном кабинете или
												на электронную почту, указанную Пользователем при регистрации на Веб-сайте. Информационные
												сообщения могут отправляться Пользователю в Приложении.
											</li>
										</ol>
									</li>

									<li>
										<div>Ответственность Пользователя</div>

										<ol>
											<li>
												6.1. Пользователь несет ответственность за нарушение своих обязательств в соответствии с
												действующим законодательством и условиями Соглашения.
											</li>
											<li>
												6.2. В случае нарушения Пользователем условий Соглашения, Musicabinet вправе в любой момент в
												одностороннем порядке приостановить предоставление доступа к Сервису и Дополнительным
												функциональным возможностямй Веб-сайта до полного устранения Пользователем допущенных нарушений.
												Восстановление доступа к Сервисам и дополнительным функциональным возможностям Веб-сайта
												осуществляется в течение 5 (пяти) рабочих дней с даты устранения Пользователем нарушений по
												запросу Пользователя.
											</li>
											<li>
												6.3. В случае грубого, неприемлемого поведения Пользователя на Веб-сайте, в Приложении,
												нарушения условий Соглашения, требований действующего законодательства Российской Федерации
												Musicabinet вправе в одностороннем порядке заблокировать Пользователю доступ к Сервисам и
												Дополнительным функциональным возможностям Веб-сайта. При этом денежные средства, уплаченные
												Пользователем за дополнительные функциональные возможности Веб-сайта возврату не подлежат.
											</li>
											<li>
												6.4. Использование Пользователем Приложения не должно нарушать имущественные и/или личные
												неимущественные права третьих лиц, а также запреты и ограничения, установленные действующим
												законодательством, включая, помимо прочего: авторское право и смежные права, права на товарные
												знаки, знаки обслуживания и наименования мест происхождения товаров, права на промышленные
												образцы, права на использование изображений людей, живых или умерших, и т.д. Размещаемый
												Пользователем Контент не должен содержать информацию и/или изображения, оскорбляющие честь,
												достоинство и деловую репутацию физических лиц.
											</li>
											<li>
												6.5. Использование Приложения другими способами, не указанными в Соглашении, в том числе путем
												копирования любой части содержимого Веб-сайта, а также дизайна Веб-сайта, программного
												обеспечения и элементов базы данных, их декомпиляции и модификации, строго запрещено и влечет
												блокировку Пользователя.
											</li>
											<li>
												6.6. Приложение предназначено для удовлетворения личных и иных, не связанных с осуществлением
												предпринимательской деятельности, потребностей физических лиц. Приложение запрещено к
												коммерческому использованию.
											</li>
											<li>
												6.7. Пользователь несет ответственность за сохранение в тайне от третьих лиц своих данных (логин
												и пароль), используемых для авторизации на Сайте. Все действия, совершенные на Сайте с
												использованием логина и/или пароля Пользователя, рассматриваются как действия самого
												Пользователя.
											</li>
											<li>
												6.8. Пользователь обязан использовать Сервисы надлежащим образом. В частности, Пользователь не
												должен вмешиваться в их работу или получать к ним доступ в нарушение стандартного интерфейса и
												инструкций. Пользователь обязан пользоваться Услугами только в соответствии с законом.
											</li>
										</ol>
									</li>

									<li>
										<div>Заключительные условия</div>

										<ol>
											<li>
												7.1. Соглашение регулируется законодательством Российской Федерации. Положения действующего
												законодательства Российской Федерации применяются постольку, поскольку они прямо не
												предусмотрены Соглашением. Преимущество имеют условия Соглашения в случае противоречия с
												действующим законодательством Российской Федерации.
											</li>
											<li>
												7.2. Споры по Соглашению разрешаются в обязательном досудебном порядке, предусматривающим
												направление претензии Пользователя в адрес Musicabinet. Срок рассмотрения претензии – 10 рабочих
												дней с даты ее получения.
											</li>
											<li>
												7.3. В случае неспособности Сторон прийти к соглашению, спор подлежит рассмотрению судом по
												месту нахождения Ответчика в соответствии с действующим законодательством РФ.
											</li>
											<li>
												7.4. Любые уведомления и претензии по Соглашению могут быть отправлены одной Стороной другой
												Стороне (на выбор отправителя): по электронной почте; путем отправки электронного сообщения
												Пользователю в его Личном кабинете; письмом по почте с уведомлением о вручении или курьерской
												службой.
											</li>
											<li>7.5. Территорией действия соглашения – является Российская Федерация.</li>
											<li>7.6. Срок действия Соглашения – в течение всего срока работы Веб-сайта, Приложения.</li>
											<li>
												7.5. В случае, если одно или несколько условий Соглашения по какой-либо причине являются
												недействительными, такая недействительность не влияет на действительность любого другого
												положения Соглашения, которое остается в силе.
											</li>
											<li>
												7.6. В случае нарушения прав и/или интересов Пользователя при использовании Приложения, в том
												числе незаконного размещения материала другим Пользователем, Пользователю, чьи права нарушены,
												следует сообщить об этом Musicabinet. Для этого Пользователю необходимо отправить уведомление в
												адрес технической поддержки с подробным описанием обстоятельств нарушения и гипертекстовую
												ссылку на страницу сайта, содержащую материалы, нарушающие права и/или интересы Пользователя.
											</li>
											<li>
												7.7. В случае, если Musicabinet будет привлечен к ответственности в связи с нарушениями
												Пользователем прав третьих лиц, запретов или ограничений, установленных законом, Пользователь
												обязан возместить полную сумму ущерба Musicabinet.
											</li>
											<li>
												7.8. Musicabinet оставляет за собой право размещать ссылки на другие ресурсы в специальных
												блоках на Веб-сайте, при этом Musicabinet не несет ответственности за доступность таких
												ресурсов, за их содержание, а также за любые последствия, возникшие из использования таких
												ресурсов и их содержания.
											</li>
										</ol>
									</li>
								</ol>
							</div>
						</Content>
					</Container>
				)}

				{settingsStore.lang !== "ru" && (
					<Container>
						<Title>User Agreement</Title>

						<Content>
							<div>
								<ol>
									<li>
										<div>General Provisions</div>

										<ol>
											<li>
												The following terms and definitions shall apply in this document:
												<ol>
													<li>User Agreement is the present document with all the additions and changes.</li>
													<li>
														User is an individual who has obtained the user profile in the Application according to
														established procedure.
													</li>
													<li>
														Website is a set of integrated hardware and software available on the Internet and located
														at the musicabinet.com domain and all the subdomain zones and/or Android or iOS app (Google
														Play and AppStore accordingly)
													</li>
													<li>
														User Account is the Authentication and Personal Information stored on the servers of the
														Website.
													</li>
													<li>
														Application is a program and/or database, including the Website and mobile applications,
														designed to provide access to the Service using the consumer Device.
													</li>
													<li>
														Musicabinet is a commercial company that provides distance learning services for the various
														musical instruments using the Application.
													</li>
													<li>
														Device is a personal computer, a tablet, a mobile phone, a communicator, a smartphone, or
														other device that allows to use the Application based on its functional purpose.
													</li>
													<li>
														Service is a set of services that are provided by Musicabinet to the User using the
														Application.
													</li>
													<li>
														Content is images, text, audio and video materials, as well as other items of copyright
														and/or related rights, as well as information and communications of any nature other than
														above mentioned in the Application.
													</li>
													<li>
														Profile is the personal section of the Website to which the User has access after signing up
														and authorization on the Website. My Own Cabinet is designed to store the User's personal
														information, view and manage the available Service functionality according to the terms of
														use of the Service.
													</li>
													<li>
														Additional Website Functionality are the Application functionality provided on the website.
													</li>
												</ol>
											</li>
											<li>
												This "User Agreement" is a proposal for granting a non-exclusive right to use the Application
												under the terms of this User Agreement.
											</li>
											<li>
												Other terms and definitions not specified in Clause 1.1 hereof may be used in this Agreement. In
												this case the interpretation of the term shall be in accordance with the text of the Agreement.
											</li>
											<li>
												The User can use the Application within their declared functionality and purpose, including:
												<ol>
													<li>signing up and/or authorization on the Website.</li>
													<li>selection and payment of training programs and courses.</li>
													<li>viewing Materials posted on the Website, including for training purposes.</li>
													<li>viewing training statistics for self-monitoring.</li>
													<li>sending text messages with media items to other users of the Application.</li>
													<li>
														placement or displaying any User's content (including his/her own) on the Website, subject
														to the limitations of Clause 7, Section 2.
													</li>
													<li>selection and payment for items at the online store.</li>
												</ol>
											</li>

											<li>
												The full and unconditional acceptance by the User of the terms of the following documents
												(hereinafter, "binding instruments") is a prerequisite for the use of the Application and the
												provision of the Service:
												<ol>
													<li>
														User Agreement (this document) that governs the procedure of the Application functionality
														use.
													</li>
													<li>
														Privacy Policy that determines the procedure of users' personal information collection,
														processing, and storage.
													</li>
												</ol>
											</li>

											<li>
												Using any possibility specified in Clause 1.4., you confirm that:
												<ol>
													<li>
														Have read the terms of this Agreement in full before using the Application and/or the
														Service provided based on it.
													</li>
													<li>
														Accept all the terms of this Agreement in full, without any exceptions or limitations on
														your part, and agree to abide by them or stop using the Application. If you do not agree to
														the terms of this Agreement, you should immediately stop any use of the Application and the
														Service provided based on it.
													</li>
												</ol>
											</li>
										</ol>
									</li>

									<li>
										<div>General Service Use Conditions</div>

										<ol>
											<li>
												Viewing the Content placed at the Application on open access does not require you to sign up
												and/or authorize the User.
											</li>
											<li>
												Any other Application functionality use is allowed only after the User has completed the signing
												up and authorization in the Application in accordance with the established rules.
											</li>
											<li>
												The list of the Application functionality that require prior signing up and authorization, as
												well as acceptance of additional documents for the use of the Services, where necessary, is
												determined by Musicabinet in sole discretion and may be changed.
											</li>
											<li>
												Information about the User in the User Account and Profile is stored and processed by
												Musicabinet in accordance with the Privacy Policy.
											</li>
											<li>
												The registered User independently determines the use of Profile and other functionality of the
												Application, which, however, may not, under any circumstances, contradict this Agreement.
											</li>
											<li>
												The User agrees to accept the granted right to use the Application under the specified
												conditions, as well as the right to use the Additional Functionality according to the selected
												tariff, and to pay a fee if it is provided for in the terms of the tariff.
											</li>
											<li>
												The User is not allowed to use the Application to:
												<ol>
													<li>
														copy the Content of the Application, as well as the design, programs, and databases that are
														part of the Application, decompile and modify them.
													</li>
													<li>place and/or distribute the pirated Content.</li>
													<li>
														place and/or distribute the Content of pornographic nature, as well as promote pornography
														and child erotica, and advertising of intimate services.
													</li>
													<li>
														place and/or distribute any other prohibited information, including materials of extremist
														nature and aimed at the infringement of human rights and freedoms on the grounds of race,
														nationality, religion, language, and sex, inciting to commitment of violent acts against a
														person or to inhuman treatment of animals, calling for the commission of other illegal acts,
														including clarifying the manufacture and use of weapons, narcotic drugs and their
														precursors, etc.
													</li>
													<li>
														place and/or distribute information from identity documents or private financial
														information.
													</li>
													<li>
														distribute advertisements in personal communications to other End Users without their prior
														consent (JUNK).
													</li>
													<li>
														distribute information inducing children to commit acts that endanger their lives and/or
														health, including the infliction of harm to their health, suicide.
													</li>
													<li>
														distribute information that can call children to use narcotic drugs, psychotropic and/or
														intoxicating substances, tobacco, alcohol and alcohol-containing products, beer and
														beverages derived from it, take part in gambling, engage in prostitution, vagrancy or
														begging.
													</li>
													<li>
														distribute information justifying the permissibility of violence and/or cruelty or inducing
														to carry out violent actions against people or animals.
													</li>
													<li>
														distribute information denying family values and causing disrespect for parents and/or other
														family members.
													</li>
													<li>distribute information justifying unlawful conduct.</li>
													<li>distribute information containing strong language.</li>
												</ol>
												<li>Violation of rules in Sub-Clause</li>
												<li>causes a user to be blocked from using the Application</li>
												<li>
													Despite the prohibition, if you use the Application, you may see the Content that may be
													deemed to contain offensive or indecent information and otherwise violate the applicable law
													and the rights of third parties. Please contact technical support in that case. Your request
													will be processed immediately and the corresponding Content deleted if the violations of this
													Agreement are confirmed.
												</li>
											</li>
										</ol>
									</li>

									<li>
										<div>Rights and Obligations of the Parties</div>

										<ol>
											<li>
												Musicabinet shall be obliged to:
												<ol>
													<li>
														Notify the User of the change of tariffs to pay for the granted right to use the Additional
														Functionality of the Website at least 10 days before the introduction of new tariffs over
														email.
													</li>
													<li>Perform other obligations under applicable law as well as this Agreement.</li>
													<li>
														Grant the User the right to functional use of the Application within the functionality of
														the Service, as well as the right to use the Additional Functionality according to the
														selected tariff.
													</li>
													<li>Provide the Service performance and technical support to the Users.</li>
													<li>
														Immediately respond to claims of rights holders on intellectual property rights violation in
														connection with the use of the Application. Musicabinet does not allow violations of
														intellectual property rights on its Website and will remove or disable access to the Content
														that violates intellectual property rights if the violation is properly confirmed.
													</li>
												</ol>
											</li>
											<li>
												Musicabinet shall be entitled to:
												<ol>
													<li>
														Terminate the Agreement with the User or suspend it if the User violates the requirements of
														this User Agreement, as well as in cases established by this Agreement and the law.
													</li>
													<li>
														Withhold the right to use the Additional Functionality of the Application before it is paid.
													</li>
													<li>
														Suspend the User's access to the Additional Functionality of the Website in the event of
														expiration of the access period if such limitations are provided for by the tariff used.
													</li>
													<li>
														Restrict single User's actions if such actions endanger the normal operation of the
														Services;
													</li>
													<li>Perform scheduled preventive maintenance that may disrupt the Website operation.</li>
													<li>Modify unilaterally the terms of this User Agreement.</li>
													<li>
														In the case of multiple breaches of the terms of the Agreement and/or the requirements of
														the law, Musicabinet reserves the right to fully block your profile (account) or limit
														(terminate) the granting of the right to use the Services for a specific period.
													</li>
													<li>
														Musicabinet reserves the right to unilaterally remove any Content from the Website or to
														temporarily restrict access to it.
													</li>
													<li>
														if Musicabinet removed the Content as violating someone's rights or laws and you believe
														that the Content has been deleted incorrectly, you have the right and the ability to
														challenge it by writing a letter to the technical support.
													</li>
												</ol>
											</li>
											<li>
												The User shall be obliged to:
												<ol>
													<li>Comply with the procedures for the Application using, established by this Agreement.</li>
													<li>Perform other obligations under applicable law as well as this User Agreement.</li>
												</ol>
											</li>
											<li>
												The User shall be entitled to:
												<ol>
													<li>Unilaterally withdraw from the execution of the User Agreement.</li>
													<li>Exercise other rights under applicable law as well as this User Agreement.</li>
												</ol>
											</li>
										</ol>
									</li>

									<li>
										<div>Provision of the Additional Functionality and Settlement Procedure</div>

										<ol>
											<li>
												The User's right to use the Additional Functionality of the Website is subject to the terms of
												the tariff selected by the User, depending on the name, composition, and amount of rights
												granted.
											</li>
											<li>
												Payment of the granted rights to use the Additional Functionality of the Website is made by the
												User in the form of a one-time payment or a subscription fee, depending on the tariff selected.
											</li>
											<li>
												The settlements under the Agreement are performed by means of wire transfer in the manner
												provided by the Application.
											</li>
											<li>Payment for the rights to use the Additional Functionality is made by advance payments.</li>
										</ol>
									</li>

									<li>
										<div>Warranties and Liability of Musicabinet</div>

										<ol>
											<li>
												Since the Services and Additional Functionality of the Website are in the process of being
												continually updated and supplemented with new functionality and the Content, the name and
												composition of the features provided may vary from time to day without prior notice to the User.
												Musicabinet has the right to terminate (temporarily or permanently) any separate service
												functions of the Service and the Additional Functionality of the Website without prior notice to
												the specific User.
											</li>
											<li>
												Musicabinet is not responsible for interruptions of the Services and the Additional
												Functionality of the Website in the event of failure of software or third-party equipment
												(Internet service providers and others).
											</li>
											<li>
												Musicabinet is not responsible to the User for suspending the Services and Additional
												Functionality of the Website on the basis of the requirement of the competent public authority.
											</li>
											<li>
												Musicabinet is not responsible for interruptions in access and use of the Services and
												Additional Functionality of the Website, related to the replacement of equipment, software or
												other works caused by maintenance and development of the Application's hardware, provided the
												User is notified of interruption of the Services and Additional Functionality of the Website.
											</li>
											<li>
												Musicabinet is not responsible for the operation and accessibility of the individual segments of
												the communication network. Musicabinet does not guarantee the ability to exchange information
												with those nodes or servers that are temporarily or permanently unavailable through the
												communication network.
											</li>
											<li>
												Musicabinet is not responsible for ensuring the security of the User's hardware and software
												used to operate the Services and Additional Functionality of the Website.
											</li>
											<li>
												Musicabinet is not responsible for the User's actions in connection with the use of the Services
												and Additional Functionality of the Website.
											</li>
											<li>
												The cumulative liability of Musicabinet under the Agreement is in any case limited to the
												documented damage to the User in the amount not exceeding the value of the granted rights paid
												for the calculation period in which such damage was caused.
											</li>
											<li>
												Musicabinet can send informational messages. Informational messages can be sent based on the
												User's actions in the Application or on the occurrence of events in the interaction between the
												User and the Application.
											</li>
										</ol>
									</li>

									<li>
										<div>Liability of the User</div>

										<ol>
											<li>
												The User is liable for the breach of his/her obligations under this Agreement in accordance with
												the applicable law and the terms of the Agreement.
											</li>
											<li>
												In the event that the User violates the requirements of the current Agreement, Musicabinet is
												entitled to suspend unilaterally the granting of access to the Service and Additional
												Functionality of the Website until the User completely eliminates the violations made.
												Restoration of access to the Services and Additional Functionality of the Website is performed
												by Musicabinet within five (5) business days from the date the User eliminates the violations.
											</li>
											<li>
												In the event of the User's gross, unacceptable behavior on the Website, breach of the terms of
												this Agreement, Musicabinet may unilaterally block the User from accessing the Services and
												Additional Functionality of the Website. Herewith, the funds paid by the User for the Additional
												Functionality of the Website are not returned.
											</li>
											<li>
												The use by the User of the Application for specific purposes shall not violate the property
												and/or personal non-property rights of third parties, as well as the prohibitions and
												restrictions established by the applicable law, including without limitation: copyright and
												related rights, trademark rights, service marks and appellations of origin, right to industrial
												designs, rights to use images of people, living or deceased, etc. The Content placed by the User
												shall not contain information and/or images that offend the honor, dignity and business
												reputation of individuals; the User has obtained all necessary permissions from the authorized
												persons in connection with the use of the Content.
											</li>
											<li>
												The use of the Application in other ways, including by copying the Content on the Website as
												well as the Website design, software and database elements, their decompilation and
												modification, is strictly prohibited and results in blocking the User.
											</li>
											<li>
												The Application is intended for personal and other, unrelated to business activities
												realization, needs of individuals. The Application is not allowed for commercial use.
											</li>
											<li>
												The User is responsible for keeping secret from third parties his/her data (login and password)
												used for authorization on the Website. All actions performed on the Website using the User's
												login and/or password are considered as the User's own actions.
											</li>
											<li>
												The User shall use the Services properly. In particular, the User shall not interfere in their
												work or gain access to them in contravention the standard interface and instructions. The User
												shall use the Services only in accordance with the law.
											</li>
										</ol>
									</li>

									<li>
										<div>Final Conditions</div>

										<ol>
											<li>
												Disputes under the Agreement shall be resolved according to the preliminary complaint procedure.
												In the event of a failure by the Parties to reach an agreement, the dispute is to be considered
												by the court at the location of Musicabinet governed by the local legislation.
											</li>
											<li>
												Any notifications under the Agreement, unless otherwise provided by the Agreement, may be sent
												by one Party to the other Party: (1) by electronic mail; (2) by sending an electronic message to
												the User in My Own Cabinet; (3) by mail with a delivery notice or courier service.
											</li>
											<li>
												In the event that one or more provisions of the Agreement are, for any reason, null and void,
												such invalidity does not affect the validity of any other provision of the Agreement that
												remains in effect.
											</li>
											<li>
												In the event of a violation of your rights and/or interests by using the Application, including
												the illegal posting of the material by another User, you should inform Musicabinet. To do this,
												you need to send a notification detailing the circumstances of the violation and a hypertext
												link to the Website page containing materials that violate your rights and/or interests to the
												technical support address.
											</li>
											<li>
												In the event that Musicabinet is prosecuted or set a punishment in respect of violations of the
												rights of third parties by you and the prohibitions or restrictions imposed by law, you are
												required to pay the full amount of damages of Musicabinet.
											</li>
											<li>
												Musicabinet reserves the right to place links to other resources in special blocks on the
												Website, upon that Musicabinet is not responsible for the availability of such resources, for
												their content, and for any consequences arising from the use the resource data and their
												content.
											</li>
										</ol>
									</li>
								</ol>
							</div>
						</Content>
					</Container>
				)}
			</ContactPageContainer>
		</>
	);
});
